import defaultTheme from './default';
import listTheme from './list';

export default {
  default: defaultTheme,
  list: listTheme,
};

export const overrides = {
  body: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
  },
  button: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
  },
  typography: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
    h1: {
      fontSize: '3rem',
    },
    h2: {
      fontSize: '2rem',
    },
    h3: {
      fontSize: '1.64rem',
    },
    h4: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1.285rem',
    },
    h6: {
      fontSize: '1.142rem',
    },
  },
};
